import $ from 'jquery';
export default function animateDivs() {
  $('.animate:not(.animated)').each( function() {
    const $animated = $(this);
    if ( $animated.isInViewport() ) {
      $animated.addClass('animated')
    }
  })
}



// WEBPACK FOOTER //
// ./js/so-animate.js